import { createAction } from '../../../../store.model';
import { OrderBy } from '../model/order-by.model';
import { ActionType } from '../task-list-dialog.action';

export interface SortItems {
    orderBy?: OrderBy;
}

export const sortItems = createAction<ActionType, SortItems>(
    ActionType.TC__TL__SORT_ITEMS,
);
